var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14 3.688h-1.35l-.284-2.12S12.222.361 12.076.21A.703.703 0 0 0 11.67 0H2.318s-.226.02-.408.209c-.145.152-.29 1.36-.29 1.36l-.284 2.12H0v2.057l1.038.163-.136 1.012v5.602a.48.48 0 0 0 .485.477h.882a.481.481 0 0 0 .485-.477v-1.325h8.479v1.325a.48.48 0 0 0 .485.477h.882a.48.48 0 0 0 .485-.477V6.921l-.136-1.01L14 5.747V3.688zM2.747 8.871a.844.844 0 0 1-.852-.837c0-.462.381-.837.852-.837.47 0 .85.375.85.837a.844.844 0 0 1-.85.837zm8.486 0a.844.844 0 0 1-.851-.837c0-.462.381-.837.851-.837s.852.375.852.837a.844.844 0 0 1-.852.837zM1.817 5.193l.392-3.407h9.524l.435 3.407H1.818z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#282828",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    fill: "#A1A1A1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.833-6.5h25.667v26H-5.833z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusGray);
export default __webpack_public_path__ + "static/media/bus_gray.3b163b79bcaac6a43d773e78bff596d5.svg";
export { ForwardRef as ReactComponent };